import React from 'react';
import moment from 'moment';
import RangePicker from '@/pages/home/components/RangePicker';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import { getShowLabel } from '../../utils';
import { toDateTypeFilter } from '@intelligence/utils/common';
import { IDatePickerProps } from '../../type';

export default function DatePicker(props: IDatePickerProps) {
  // console.log(props);
  const { value, field, onChange, formItem } = props;
  const { formatMessage, isCN } = useIntlExtend();

  const getDatePickerValue = (selected = []) => {
    const [ startDate, endDate ] = selected;
    return [moment(startDate), moment(endDate || startDate)];
  };
  return (
    <div className="search-item-date">
      <RangePicker
        type={toDateTypeFilter[value?.type] || 'month'}
        className="search-border"
        overlayClassName="dbi-high-layer"
        typeSelectOverlayClassName="dbi-high-layer"
        value={getDatePickerValue(value?.value)}
        showSelectType={false}
        language={isCN ? 'cn' : 'en'}
        onChange={(value: any, type: any) => {
          onChange(field, {
            type,
            value,
          });
        }}
      />
      {getShowLabel(formItem, formatMessage, 'msg') && <TipContext AWidth={381} tipText={getShowLabel(formItem, formatMessage, 'msg')} className="dbi-tip-icon" />}
    </div>
  );
}
